import { render } from "./CoursesCategoryCard.vue?vue&type=template&id=40b0aa1a&scoped=true"
import script from "./CoursesCategoryCard.vue?vue&type=script&lang=js"
export * from "./CoursesCategoryCard.vue?vue&type=script&lang=js"

import "./CoursesCategoryCard.vue?vue&type=style&index=0&id=40b0aa1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b0aa1a"]])

export default __exports__